import { useState } from 'react'
import { downloadDocument } from '../utils/commonUtil'

export default function ResultCard({ jobId, jobData, jobType = 'smp', error, onReset }) {
  const [downloading, setDownloading] = useState(false)
  const isSuccess = !error
  const isRaid    = jobType === 'raid'
  const isTvr     = jobType === 'tvr'

  const lastLog    = jobData?.logs?.at(-1)?.replace(/^\[.*?\]\s*/, '') ?? ''
  const baseName   = (jobData?.sow_filename ?? 'Generated').replace(/\.[^.]+$/, '')
  const dlFilename = isTvr ? `TVR_${baseName}.xlsx` : isRaid ? `RAID_${baseName}.xlsx` : `SMP_${baseName}.docx`
  const dlLabel    = isTvr ? 'Download TVR Tracker' : isRaid ? 'Download RAID Tracker' : 'Download SMP Document'
  const successMsg = isTvr ? 'TVR Tracker Generated Successfully!' : isRaid ? 'RAID Tracker Generated Successfully!' : 'SMP Generated Successfully!'
  const resetLabel = isTvr ? '↩  Analyse another SOW' : isRaid ? '↩  Analyse another SOW' : '↩  Generate another SMP'

  async function handleDownload() {
    setDownloading(true)
    try {
      await downloadDocument(jobId, dlFilename)
    } catch (err) {
      if (err?.message) alert(err.message)
    } finally {
      setDownloading(false)
    }
  }

  return (
    <div className="c-card">
      <div className={`c-result-banner${error ? ' is-error' : ''}`}>
        <span className="c-result-emoji">{isSuccess ? '✅' : '❌'}</span>
        <div className="c-result-body">
          <h3>{isSuccess ? successMsg : 'Generation Failed'}</h3>
          <p>{error ?? lastLog ?? 'Your file is ready to download.'}</p>
        </div>
      </div>

      {isSuccess && (
        <button className="c-btn-download" onClick={handleDownload} disabled={downloading}>
          {downloading
            ? <><span className="c-spinner c-spinner-white" />&nbsp;Downloading…</>
            : <>⬇&nbsp; {dlLabel}</>
          }
        </button>
      )}

      <button className="c-btn-secondary" onClick={onReset}>{resetLabel}</button>
    </div>
  )
}
